import { Avatar } from "@mui/material";
import { LmsTrainingDefaultThumbnailUrl } from "views/lms/components/LmsTypeImage";
import { useEnrollmentViewContext } from "..";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    size?: "extra-small" | "small" | "medium";
}

export const TrainingAvatar = ({ size = "medium" }: IProps) => {

    const { enrollment } = useEnrollmentViewContext();

    return <Avatar
        variant="rounded"
        sx={size == "small" ? { width: 107, height: 60 } : size == "extra-small" ? { width: 70, height: 40, borderRadius: "4px" } : { width: 220, height: 124 }}
        src={LmsTrainingDefaultThumbnailUrl(enrollment.trainingContentType, enrollment.trainingThumbnailUrl)}
    />;
};
